"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.symbol = symbol;
function symbol() {
    // eslint-disable-next-line max-len,quotes
    return '<symbol viewbox="0 0 16 16" id=icon-notification-16><path fill-rule=evenodd clip-rule=evenodd d="M5 5a3 3 0 0 1 6 0v2.214a2 2 0 0 0 .302 1.057L13.001 11H3l1.698-2.73A2 2 0 0 0 5 7.214V6.012A.99.99 0 0 0 5 6V5Zm-2 .5V5a5 5 0 1 1 10 0v2.214l1.699 2.73c.829 1.332-.13 3.057-1.698 3.057H11a3 3 0 0 1-6 0H3C1.43 13 .471 11.276 1.3 9.944L3 7.214V5.5ZM7 13h2a1 1 0 0 1-2 0Z"></path></symbol>';
}
